import { HazardIconProps, HazardPictogramCode } from './constants';
import { Ghs01Icon } from './ghs01';
import { Ghs02Icon } from './ghs02';
import { Ghs03Icon } from './ghs03';
import { Ghs04Icon } from './ghs04';
import { Ghs05Icon } from './ghs05';
import { Ghs06Icon } from './ghs06';
import { Ghs07Icon } from './ghs07';
import { Ghs08Icon } from './ghs08';
import { Ghs09Icon } from './ghs09';

const iconsByCode: Record<HazardPictogramCode, (props: HazardIconProps) => React.JSX.Element> = {
  GHS01: Ghs01Icon,
  GHS02: Ghs02Icon,
  GHS03: Ghs03Icon,
  GHS04: Ghs04Icon,
  GHS05: Ghs05Icon,
  GHS06: Ghs06Icon,
  GHS07: Ghs07Icon,
  GHS08: Ghs08Icon,
  GHS09: Ghs09Icon,
};

function isHazardPictogramCode(code: string): code is HazardPictogramCode {
  return Object.hasOwn(iconsByCode, code);
}

export const HazardPictogramIcon = ({ code, size }: HazardIconProps & { code: string }) => {
  if (!isHazardPictogramCode(code)) {
    return null;
  }
  const Icon = iconsByCode[code];
  return <Icon size={size} />;
};
